/**
 * Clasificación de los documentos de un expediente.
 *
 * ── Por qué son DOS campos y no un desplegable de cuatro ────────────────────
 * La primera propuesta era una sola lista: «factura / contrato / otros público /
 * otros privado». Mezcla dos preguntas distintas —*qué es* el documento y *quién
 * puede verlo*— y con eso no hay forma de expresar «contrato que NO se manda»,
 * que es un caso real: un contrato con anexos internos, o uno que el cliente no
 * quiere que circule.
 *
 * Separados, el filtro de lo que se manda solo pregunta por el segundo, y nadie
 * tiene que mantener una lista de categorías «públicas» que alguien olvidará
 * actualizar al añadir la siguiente.
 *
 * ── Esto es solo para expedientes AR ────────────────────────────────────────
 * Decidido con Edgar el 16/10/2026. En recobro y judicial los documentos no se
 * le mandan al deudor desde aquí, así que la pantalla no ofrece estos campos.
 */

/**
 * Qué es el documento.
 *
 * ⚠️ El campo se llama `document_category` y **no** `file_type`: ese ya existe
 * justo al lado en el mismo subdocumento y es el **MIME** (`application/pdf`),
 * que se le pasa a S3 como content type. Dos campos casi homónimos juntos es
 * exactamente cómo alguien lee el que no es dentro de seis meses.
 */
const DOCUMENT_CATEGORIES = ['factura', 'contrato', 'otro'];

const DOCUMENT_CATEGORY_LABELS = {
  factura: 'Factura',
  contrato: 'Contrato',
  otro: 'Otro',
};

/**
 * La categoría de un documento que nadie ha clasificado.
 *
 * `null`, no `'otro'`: hay miles de documentos subidos antes de que esto
 * existiera, y decir que son «otro» sería afirmar algo que nadie ha mirado.
 * Sin clasificar es un estado legítimo y hay que poder verlo en la pantalla.
 */
const DEFAULT_DOCUMENT_CATEGORY = null;

/**
 * 🔴 **Por defecto NO se le puede mandar al deudor.**
 *
 * Es la decisión que más importa de todo esto. Los documentos que ya estaban no
 * tienen el campo, y los valores por defecto de mongoose **no alcanzan a los
 * documentos que ya existían**. Si el valor por defecto fuera «sí», el día que
 * se encienda el envío automático empezaríamos a mandarle a cada deudor lo que
 * hubiera en su expediente — y eso no es un fallo de producto, es un incidente
 * de protección de datos.
 *
 * Por el mismo motivo **la categoría no se deduce del nombre del fichero**: un
 * `factura_2026.pdf` puede ser cualquier cosa.
 *
 * Y si un expediente pasa a AR más tarde, sus documentos llegan sin clasificar
 * y por tanto no enviables, que es lo correcto — pero alguien tiene que saber
 * que hay que clasificarlos.
 */
const DEFAULT_SHAREABLE_WITH_DEBTOR = false;

module.exports = {
  DOCUMENT_CATEGORIES,
  DOCUMENT_CATEGORY_LABELS,
  DEFAULT_DOCUMENT_CATEGORY,
  DEFAULT_SHAREABLE_WITH_DEBTOR,
};
